import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../components/Login')
  },
  {
    path: '/openId',
    name: 'openId',
    component: () => import('../pages/openId')
  },
  {
    path: '/expressway/ztdp',
    name: 'screen',
    component: () => import('../pages/screen')
  },
  {
    path: '/expressway/gzztdp',
    name: 'screen',
    component: () => import('../pages/gzztscreen')
  },
  {
    path: '/expressway/dutyScreen',
    component: () => import('../pages/duty/dutyScreen'),
    name: 'dutyScreen'
  },
  {
    path: '/expressway/screen',
    name: 'screens',
    component: () => import('../pages/screens')
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: () => import('../components/layout/homepage'),
    redirect: '/expressway/index',
    children: [
      {
        path: '/expressway/index',
        component: () => import('../pages/firstPage'),
        name: 'firstPage'
      },
      {
        path: '/expressway/dev-sbgl',
        component: () => import('../pages/device'),
        name: 'dev-sbgl'
      },
      {
        path: '/expressway/dev-jt808',
        component: () => import('../pages/jt808'),
        name: 'dev-jt808'
      },
      {
        path: '/expressway/jkzx',
        name: 'monitor',
        component: () => import('../pages/monitor')
      },
      {
        path: '/expressway/gjddt-jkzx',
        name: 'monitorLeaflet',
        component: () => import('../pages/monitorLeaflet')
      },
      {
        path: '/expressway/sszz',
        name: 'tracking',
        component: () => import('../pages/tracking')
      },
      {
        path: '/expressway/zhzy-zyjk',
        name: 'missionMap',
        component: () => import('../pages/missionMap')
      },
      {
        path: '/expressway/zhzy-spjk',
        name: 'wvp',
        component: () => import('../pages/missionMap2')
      },
      {
        path: '/expressway/tjfx-gjtj-wlbjhz',
        name: 'analyseCaution',
        component: () => import('../pages/analyseCaution')
      },
      {
        path: '/expressway/tjfx-gjtj-sblctj',
        name: 'analyseMiles',
        component: () => import('../pages/analyseMiles')
      },
      {
        path: '/expressway/tjfx-gjtj-sbbjmx',
        name: 'deviceWarnDetail',
        component: () => import('../pages/deviceWarn')
      },
      {
        path: '/expressway/dzwl',
        name: 'fence',
        component: () => import('../pages/fence')
      },
      {
        path: '/expressway/gjhf',
        name: 'replay',
        component: () => import('../pages/replay')
      },
      {
        path: '/expressway/xtgl-user',
        component: () => import('../pages/account'),
        name: 'account'
      },
      {
        path: '/expressway/xtgl-role',
        component: () => import('../pages/role'),
        name: 'role'
      },
      {
        path: '/expressway/xtgl-sysOperLog',
        component: () => import('../pages/sysOperLog'),
        name: 'sysOperLog'
      },
      {
        path: '/expressway/zzgl',
        component: () => import('../pages/organization'),
        name: 'organization'
      },
      {
        path: '/expressway/zhzy-rwgl',
        component: () => import('../pages/missions'),
        name: 'missions'
      },
      {
        path: '/expressway/zhzy-zytj',
        component: () => import('../pages/jiaoanhome'),
        name: 'jiaoanhome'
      },
      {
        path: '/expressway/xtgj-sjcd',
        component: () => import('../pages/dictionary'),
        name: 'dictionary'
      },
      {
        path: '/expressway/zhzy-rygl',
        component: () => import('../pages/employee'),
        name: 'employee'
      },
      {
        path: '/expressway/warningPage',
        component: () => import('../pages/warningPage'),
        name: 'warningPage'
      },
      {
        path: '/expressway/gjddt-gjhf',
        component: () => import('../pages/leaflet'),
        name: 'leaflet'
      },
      {
        path: '/expressway/gjddt-sszz',
        component: () => import('../pages/trackingLeaflet'),
        name: 'leaflet'
      },
      {
        path: '/expressway/jt1078-playback',
        component: () => import('../pages/playback'),
        name: 'playback'
      },
      {
        path: '/expressway/active-safety',
        component: () => import('../pages/activesecurity'),
        name: 'activesecurity'
      },
      {
        path: '/expressway/jt1078-realtime',
        component: () => import('../pages/trackingVideo'),
        name: 'trackingVideo'
      },
      {
        path: '/expressway/sbsj',
        component: () => import('../pages/otaFileList'),
        name: 'otaFileList'
      },
      {
        path: '/expressway/zlsq',
        component: () => import('../pages/deviceModel'),
        name: 'deviceModel'
      },
      {
        path: '/expressway/zhzy-bjmx',
        name: 'expresswayCaution',
        component: () => import('../pages/expresswayCaution')
      },
      {
        path: '/expressway/yqzhwl-rycl',
        component: () => import('../pages/carSharing'),
        name: 'carSharing'
      },
      {
        path: '/expressway/clgl-clxx',
        component: () => import('../pages/vehicle'),
        name: 'vehicle'
      },
      {
        path: '/expressway/clgl-htgl',
        component: () => import('../pages/lease'),
        name: 'lease'
      },
      {
        path: '/expressway/clgl-jygl',
        component: () => import('../pages/vehicleFuelCost'),
        name: 'vehicleFuelCost'
      },
      {
        path: '/expressway/clgl-wxby',
        component: () => import('../pages/vehicleMaintainence'),
        name: 'vehicleMaintainence'
      },
      {
        path: '/expressway/clgl-sjgl',
        component: () => import('../pages/driver'),
        name: 'driver'
      },
      {
        path: '/expressway/platformPage',
        component: () => import('../pages/platformPage'),
        name: 'platformPage'
      },
      {
        path: '/expressway/bjpz',
        component: () => import('../pages/cautionConfig'),
        name: 'cautionConfig'
      },
      {
        path: '/expressway/tjfx-gjtj-wltj',
        component: () => import('../pages/efenceStatistics'),
        name: 'efenceStatistics'
      },
      {
        path: '/expressway/tjfx-gjtj-wljccs',
        component: () => import('../pages/efenceInOutCount'),
        name: 'efenceInOutCount'
      },
      {
        path: '/expressway/tjfx-gjtj-wlcsc',
        component: () => import('../pages/efenceOutDuration'),
        name: 'efenceOutDuration'
      },
      {
        path: '/expressway/clgl-ydzhyhfx',
        component: () => import('../pages/vehicleFuelCostAnalysis'),
        name: 'vehicleFuelCostAnalysis'
      },
      {
        path: '/expressway/clgl-zhxxtj',
        component: () => import('../pages/vehicleInfoStatistics'),
        name: 'vehicleInfoStatistics'
      },
      {
        path: '/expressway/clgl-xmbcllyl',
        component: () => import('../pages/vehicleUtilization'),
        name: 'vehicleUtilization'
      },
      {
        path: '/expressway/clgl-lcyb',
        component: () => import('../pages/vehicleMileageMonth'),
        name: 'vehicleMileageMonth'
      },
      {
        path: '/expressway/clgl-cllxbb',
        component: () => import('../pages/vehicleOffline'),
        name: 'vehicleOffline'
      },
      {
        path: '/expressway/whiteList-alarm',
        component: () => import('../pages/alarmList'),
        name: 'alarmList'
      },
      {
        path: '/expressway/clgl-cltlbb',
        component: () => import('../pages/vehicleStop'),
        name: 'vehicleStop'
      },
      {
        path: '/expressway/clgl-clcsbb',
        component: () => import('../pages/vehicleSpeeding'),
        name: 'vehicleSpeeding'
      },
      {
        path: '/expressway/tjfx-gjtj-bjzl',
        component: () => import('../pages/cautionOverview'),
        name: 'cautionOverview'
      },
      {
        path: '/expressway/dutyPlan',
        component: () => import('../pages/duty/dutyPlan'),
        name: 'dutyPlan'
      },

      {
        path: '/expressway/dutyAssessmentRule',
        component: () => import('../pages/duty/dutyAssessmentRule'),
        name: 'dutyAssessmentRule'
      },
      {
        path: '/expressway/dutyAssessmentGroup',
        component: () => import('../pages/duty/dutyAssessmentGroup'),
        name: 'dutyAssessmentGroup'
      },
      {
        path: '/expressway/dutyReportTeamDay',
        component: () => import('../pages/duty/dutyReportTeamDay'),
        name: 'dutyReportTeamDay'
      },
      {
        path: '/expressway/dutyReportTeamAvg',
        component: () => import('../pages/duty/dutyReportTeamAvg'),
        name: 'dutyReportTeamAvg'
      },
      {
        path: '/expressway/dutyReportCityDay',
        component: () => import('../pages/duty/dutyReportCityDay'),
        name: 'dutyReportCityDay'
      },
      {
        path: '/expressway/dutyReportCityAvg',
        component: () => import('../pages/duty/dutyReportCityAvg'),
        name: 'dutyReportCityAvg'
      },
      {
        path: '/expressway/dutyReportTeamSummary',
        component: () => import('../pages/duty/dutyReportTeamSummary'),
        name: 'dutyReportTeamSummary'
      },
      {
        path: '/expressway/dutyAssessmentMyGroup',
        component: () => import('../pages/duty/dutyAssessmentMyGroup'),
        name: 'dutyAssessmentMyGroup'
      },
      {
        path: '/expressway/xtgl-sysNotice',
        component: () => import('../pages/sysNotice'),
        name: 'xtgl-sysNotice'
      },
      {
        path: '/expressway/dutyReportDistribution',
        component: () => import('../pages/duty/dutyReportDistribution'),
        name: 'dutyReportDistribution'
      },
      {
        path: '/expressway/dutyReportTeamNotQualify',
        component: () => import('../pages/duty/dutyReportTeamNotQualify'),
        name: 'dutyReportTeamNotQualify'
      },
      {
        path: '/expressway/dutyReportPatrol',
        component: () => import('../pages/duty/dutyReportPatrol'),
        name: 'dutyReportPatrol'
      },
      {
        path: '/expressway/whiteList-manage',
        component: () => import('../pages/whiteList'),
        name: 'whiteList'
      },
      {
        path: '/expressway/clgl-lwjxtz',
        component: () => import('../pages/lwjxtz'),
        name: 'lwjxtz'
      },
      {
        path: '/expressway/clgl-ytccl',
        component: () => import('../pages/ytccl'),
        name: 'ytccl'
      },
      {
        path: '/expressway/clgl-myjxsjhz',
        component: () => import('../pages/myjxsjhz'),
        name: 'myjxsjhz'
      }
    ]
  }
]
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token')
  // let token = store.state.token
  if (to.path === '/' || to.path === '/openId') {
    next()
  } else if (!token) {
    // 不存在 转跳至登录页面
    Message({
      message: '登录信息认证失败,请重新登录平台！',
      type: 'error'
    })
    sessionStorage.clear()
    next({ path: '/' })
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js